import { render } from "./ComponentPlace.vue?vue&type=template&id=0ba35b64"
const script = {}

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__